import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const AudioVisualRoom = () => {
    useEffect(() => {
        document.title = 'Audio Visual Room -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Audio Visual Room</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Audio Visual Room </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                    <p>Learning is facilitated by frequent use of the audio-visual room which is specially allocated for teaching in all academic sessions. Students are also encouraged to make use of this room for presentations by them for different projects. The air-conditioned AV Room facilitates workshop for students and teachers at regular intervals.</p>
                </div>
                <div className="col-lg-12">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/AudioVisualRoom.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/AudioVisualRoom.png" className="mx-auto d-block schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default AudioVisualRoom